// Set the base URL based on the current location, listening on navigation changes.
import { BasePattern } from "@patternslib/patternslib/src/core/basepattern";
import Parser from "@patternslib/patternslib/src/core/parser";
import registry from "@patternslib/patternslib/src/core/registry";
import events from "@patternslib/patternslib/src/core/events";
import logging from "@patternslib/patternslib/src/core/logging";
import utils from "@patternslib/patternslib/src/core/utils";

const log = logging.getLogger("details-navigation");

export const parser = new Parser("details-navigation");
parser.addArgument("breakpoint", 1024);


class Pattern extends BasePattern {
    static name = "details-navigation";
    static trigger = "details.pat-details-navigation";
    static parser = parser;

    init() {
        const mediaquerylist = window.matchMedia(`(min-width: ${this.options.breakpoint}px)`);
        events.add_event_listener(
            mediaquerylist,
            "change",
            "details-navigation-mq",
            (mql) => {
                this.set_details_state(mql);
                log.info(`mediaquery change - window.innerWidth: ${window.innerWidth}`);
            }
        );

        // Open all in-paths details elements
        const in_path_open = async () => {
            // Wait a tick, so that the current class is set.
            await utils.timeout(0);
            const details = this.el.querySelectorAll("details:has(.current)");
            console.log("details", details);
            for (const detail of details) {
                detail.setAttribute("open", "");
                console.log("detail", detail);
            }
        }

        in_path_open();

        //events.add_event_listener(
        //    window.navigation,
        //    "navigate",
        //    "pat-details-navigation--history-changed",
        //    () => {
        //        if (! this.el.hasAttribute("open")) {
        //            // Don't do any open/close changes, if the navigation is open.
        //            // This is only for changing the state in the background.
        //            // ALTERNATIVE: set the default state when the menu is opened.
        //            in_path_open();
        //        }
        //    }
        //);

        // Close the navigation on mobile devices.
        events.add_event_listener(
            window.navigation,
            "navigate",
            "pat-details-navigation--history-changed",
            () => {
                // Only close the nav after navigating on mobile devies.
                if (! mediaquerylist.matches && this.el.hasAttribute("open")) {
                    this.el.removeAttribute("open");
                }
            }
        );

        // Close on ESC
        events.add_event_listener(
            this.el,
            "keydown",
            "pat-details-navigation--close-on-esc",
            (event) => {
                if (event.key === "Escape") {
                    // Only close the main details element on mobile devices.
                    if (! mediaquerylist.matches) {
                        this.el.removeAttribute("open");
                    }
                    // TODO: Revisit and rework to close only non-in-path details.
                    //// Close all submenus on ESC
                    //for (const sub of this.el.querySelectorAll("details")) {
                    //    sub.removeAttribute("open");
                    //}
                }
            }
        );

        this.set_details_state(mediaquerylist);
    }

    set_details_state(mql) {
        log.info("set_details_state");
        if (mql.matches && ! this.el.hasAttribute("open")) {
            // Open the details navigation element
            this.el.setAttribute("open", "");
            log.info("    set open");
        } else if (! mql.matches && this.el.hasAttribute("open")) {
            // Close the details navigation element
            this.el.removeAttribute("open");
            log.info("    set closed");
        }
    }
}

registry.register(Pattern);
export default Pattern;
export { Pattern };
